import React from 'react'

type Props = {
    children?: React.ReactNode;
    align?: 'left' | 'center' | 'right';
    className?: string;
    fontSize?: number;
    colSpan?: number;
    py?: number;
    rowSpan?: number;
}

const StandardTableCell = ({ children, align, className, fontSize, colSpan, py, rowSpan }: Props) => {

    function alignClassName() {
        if (align === 'left') {
            return 'text-left'
        }
        if (align === 'center') {
            return 'text-center'
        }
        if (align === 'right') {
            return 'text-right'
        }
        return 'text-left'
    }
    return (
        <td rowSpan={rowSpan != null ? rowSpan : 1} colSpan={colSpan != null ? colSpan : 1} className={`px-2 ${alignClassName()} text-[${fontSize != null ? fontSize : 14}px] py-${py != null ? py : 2} align-middle border-[1px] text-primary-dark border-solid border-primary border-opacity-20 ${className}`}>
            {children}
        </td>
    )
}

export default StandardTableCell